// extracted by mini-css-extract-plugin
export var form = "_dd-0";